import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DropdownOption, DropdownOptionGroup, DropdownOptionIcon, DropdownOptionType, IconName, PopoverPosition } from '@yupma/ui-kit';
import { RouteLinkGenerator, RouteName } from 'src/app/routing-path';
import { IAMService, UIService } from 'src/app/services/services.module';

@Component({
  selector: 'app-bottombar',
  templateUrl: './bottombar.component.html',
  styleUrl: './bottombar.component.scss'
})
export class BottombarComponent implements OnInit {
  iconNames = IconName;
  routeNames = RouteName;
  homeRoute = RouteLinkGenerator.home('');
  searchRoute = RouteLinkGenerator.search('');
  reportsRoute = RouteLinkGenerator.reports('');
  contactsRoute = RouteLinkGenerator.contacts('');
  tasksRoute = RouteLinkGenerator.tasks('');

  dropdownOptions: DropdownOptionGroup[] = [];
  isDropdownOpen: boolean = false;
  popoverPositions = PopoverPosition;

  constructor(
    private router: Router,
    private iamService: IAMService,
    private uiService: UIService,
  ) { }

  ngOnInit() {
    const organisationId = this.iamService.getOrganisationId();
    this.homeRoute = RouteLinkGenerator.home(organisationId);
    this.searchRoute = RouteLinkGenerator.search(organisationId);
    this.reportsRoute = RouteLinkGenerator.reports(organisationId);
    this.contactsRoute = RouteLinkGenerator.contacts(organisationId);
    this.tasksRoute = RouteLinkGenerator.tasks(organisationId);
    this.createDropdown();
  }

  isActiveRoute(route: string): boolean {
    return this.router.url.includes(`/${route}`);
  }

  async toggleDropdown(state: boolean) {
    this.isDropdownOpen = state;
  }

  private createDropdown() {
    // const contactView = new DropdownOptionIcon(DropdownOptionType.DEFAULT, "Edit contact view", ContactCustomizationOption.VIEW, IconName.USER);
    const contactForm = new DropdownOptionIcon(DropdownOptionType.DEFAULT, "Create contact", '1', IconName.USER);
    const moreOptionDropdownGroup = new DropdownOptionGroup('', [contactForm]);
    this.dropdownOptions = [moreOptionDropdownGroup];
  }

  selectedOption(selectedOption: DropdownOption) {
    // console.log(selectedOption);
    this.uiService.openAddContactDrawer();
  }
}
